import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, Grid, FormControlLabel, Switch } from '@mui/material';
import { useSelector } from 'react-redux';

const AddUserDialog = ({ open, userFormData, allUsers, handleAddUserSubmit, handleChange, handleClose }) => {
    const fetchConfigData = useSelector((state) => state.config.configData);
    const handleCloseReason = (event, reason) => {
        if (reason && reason === "backdropClick") return;
        handleClose();
    }
    return (
        <Dialog fullWidth open={open} onClose={handleCloseReason}>
            <DialogTitle>{userFormData.id ? 'Edit' : 'Add New'} User</DialogTitle>
            {/* <DialogTitle>{singleRowData.title}</DialogTitle> */}
            <DialogContent>
                {/* ====================================== */}
                <form>
                    <TextField
                        label="Full Name"
                        name="fullName"
                        value={userFormData.fullName}
                        onChange={handleChange}
                        fullWidth
                        size="small"
                        margin="normal"
                        required
                    // error={userFormError.fullName}
                    // helperText={
                    //     userFormError.fullName
                    //     ? 'Enter Full name properly'
                    //     : ''
                    // }
                    />
                    {/* {userFormError.fullName && (
                        <FormHelperText size="small" sx={{ color: 'red', mt: '0' }}>
                            Enter Full name properly
                        </FormHelperText>
                    )} */}
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <TextField
                                label="Email"
                                name="email"
                                type="email"
                                value={userFormData.email}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                margin="normal"
                                required
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                select
                                label="Permission"
                                name="permission"
                                value={userFormData.permission}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                margin="normal"
                                required
                            >
                                {fetchConfigData.userPermission.map((usr, index) => (
                                    <MenuItem value={usr.name} key={index}>{usr.name}</MenuItem>
                                ))}
                                <MenuItem value="HR Management">HR Management</MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                    {!userFormData.id &&
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    label="Password"
                                    name="password"
                                    type="password"
                                    value={userFormData.password}
                                    onChange={handleChange}
                                    fullWidth
                                    size="small"
                                    margin="normal"
                                    required
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Confirm Password"
                                    name="confirmPassword"
                                    type="password"
                                    value={userFormData.confirmPassword}
                                    onChange={handleChange}
                                    fullWidth
                                    size="small"
                                    margin="normal"
                                    required
                                />
                            </Grid>
                        </Grid>
                    }
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        name="isOfficeEmp"
                                        checked={userFormData.isOfficeEmp || false}
                                        onChange={(e) => handleChange({ target: { name: 'isOfficeEmp', value: e.target.checked } })}
                                        color="primary"
                                    />
                                }
                                label="Is Office Employee"
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        name="isTeamLeader"
                                        checked={Boolean(userFormData.isTeamLeader || userFormData.is_leader || userFormData.isLeader)}
                                        onChange={(e) => {
                                            handleChange({ target: { name: 'isTeamLeader', value: e.target.checked } });
                                            handleChange({ target: { name: 'is_leader', value: e.target.checked } });
                                        }}
                                        color="primary"
                                    />
                                }
                                label="Is Team Leader"
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <TextField
                                label="Department"
                                name="department"
                                value={userFormData.department || ''}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                margin="normal"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                select
                                label="Assign Team Leader"
                                name="teamLeader"
                                value={userFormData.teamLeader?._id || userFormData.teamLeader || ''}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                margin="normal"
                            >
                                <MenuItem value=""><em>None</em></MenuItem>
                                {allUsers?.map((u) => (
                                    <MenuItem key={u.id} value={u.id}>{u.fullName}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                label="Date of Birth"
                                name="dob"
                                type="date"
                                value={userFormData.dob || ''}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                margin="normal"
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                label="Office Joining Date"
                                name="officeJoiningDate"
                                type="date"
                                value={userFormData.officeJoiningDate || ''}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                margin="normal"
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                select
                                label="Blood Group"
                                name="bloodGroup"
                                value={userFormData.bloodGroup || ''}
                                onChange={handleChange}
                                fullWidth
                                size="small"
                                margin="normal"
                            >
                                <MenuItem value=""><em>None / Select</em></MenuItem>
                                {['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'].map((bg) => (
                                    <MenuItem key={bg} value={bg}>{bg}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    </Grid>
                </form>
                {/* ====================================== */}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleAddUserSubmit} variant="contained" color="success">
                    {userFormData.id ? 'Update' : 'Add'}
                </Button>
                <Button onClick={handleClose} variant="contained" color="error">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddUserDialog;